import { guideCardHtml } from "../../elements/card/component.js";
const scalarCard = {
  name: "scalar-card",
  tagName: "scalar-card",
  tiptapName: "scalar-card",
  attributeTransform: (_, attrs) => {
    return {
      leftIcon: typeof attrs.leftIcon === "string" ? attrs.leftIcon : typeof attrs.leftIcon?.src === "string" ? attrs.leftIcon?.src : void 0,
      title: typeof attrs.title === "string" ? attrs.title : void 0,
      icon: typeof attrs.icon === "string" ? attrs.icon : void 0,
      description: typeof attrs.description === "string" ? attrs.description : void 0,
      isEditable: typeof attrs.isEditable === "boolean" ? attrs.isEditable : void 0,
      href: typeof attrs.href === "string" ? attrs.href : void 0,
      target: attrs.target === "_blank" || attrs.target === "_self" ? attrs.target : void 0
    };
  },
  render: async (props) => {
    const transformed = scalarCard.attributeTransform("", props);
    return transformed ? await guideCardHtml(transformed) : "";
  }
};
export {
  scalarCard
};
//# sourceMappingURL=index.js.map
